import { HorizontalLogo, MohaIcon } from '@assets/newlogo';
import { Link } from 'react-router';

const NavLogo = () => {
    return (
        <div>
            <Link
                className="lg:hidden block cursor-pointer focus-visible:border-1 focus-visible:border-blue-400"
                to="/"
                id="topNav_link_home"
            >
                <MohaIcon size="medium" />
            </Link>
            <Link
                className="hidden lg:block w-fit cursor-pointer focus-visible:border-1 focus-visible:border-blue-400"
                to="/"
                id="topNav_link_home"
            >
                <HorizontalLogo size="small" />
            </Link>
        </div>
    );
};

export default NavLogo;
